import UnitTransactionTable from "@/app/app-shared/unit-transaction/unit-transaction-table";

export default function UnitTransactionPage() {
  return <UnitTransactionTable />;
}
